/**
 * Hero Rooms Slider Component
 * Uses Swiper for slider functionality
 */

class HeroRoomsSlider extends HTMLElement {
  constructor() {
    super();
    this.swiper = null;
    this.init();
  }

  init() {
    // Wait for Swiper to be available
    if (typeof Swiper === 'undefined') {
      console.error('Swiper library not found');
      return;
    }

    const swiperContainer = this.querySelector('.hero-rooms-slider__slideshow');
    if (!swiperContainer) return;

    const prevButton = this.querySelector('.hero-rooms-slider__button--prev');
    const nextButton = this.querySelector('.hero-rooms-slider__button--next');
    const counterCurrent = this.querySelector('.hero-rooms-slider__counter-current');
    const autoRotate = swiperContainer.dataset.autoplay === 'true';
    const autoRotateSpeed = parseInt(swiperContainer.dataset.speed || '5') * 1000;

    this.swiper = new Swiper(swiperContainer, {
      slidesPerView: 1,
      spaceBetween: 0,
      loop: true,
      speed: 500,
      autoplay: autoRotate ? {
        delay: autoRotateSpeed,
        disableOnInteraction: false,
      } : false,
      navigation: {
        nextEl: nextButton,
        prevEl: prevButton,
      },
      on: {
        slideChange: (swiper) => {
          if (counterCurrent) {
            const realIndex = swiper.realIndex + 1;
            counterCurrent.textContent = realIndex.toString().padStart(2, '0');
          }
        },
      },
    });
  }

  disconnectedCallback() {
    if (this.swiper) {
      this.swiper.destroy(true, true);
    }
  }
}

// Register custom element
if (!customElements.get('hero-rooms-slider')) {
  customElements.define('hero-rooms-slider', HeroRoomsSlider);
}